<template>
  <div>
    <div v-if="accesscheckk == true" class="mt-16">
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </div>
    <div v-if="accesscheckk == false">
      <v-card class="pt-2 my-2" max-width="100%" v-if="Show == false" flat>
        <v-data-table
          dense
          class="elevation-1 overflow-hidden"
          :headers="headers"
          :items="expenseList"
          item-key="name"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="getExpenseApprDataPagination()"
          :no-data-text="Nodata"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ expenseList.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.user_detail`]="{ item }">
            <span class="caption"
              ><b>{{ item.user_detail.user_name }}</b></span
            >
            <br />
            <!-- </template>
         
        <template v-slot:[`item.mobile_no`]="{ item }"> -->
            <span class="caption">{{ item.user_detail.mobile_no }}</span>
          </template>
          <template v-slot:[`item.total_amount`]="{ item }">
            <span class="caption"
              >{{ item.currency }} {{ item.total_amount }}</span
            >
          </template>
          <template v-slot:[`item.transactionNumber`]="{ item }">
            <span class="caption">{{ item.transactionNumber }}</span>
          </template>

          <template v-slot:[`item.request_type`]="{ item }">
            <span v-if="item.request_type != ''" class="caption">{{
              item.request_type
            }}</span>
            <span v-if="item.request_type == ''" class="caption">-</span>
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-if="item.status == 0 || item.status == 6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING
                  </span>
                </template>
                <span>PENDING </span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption green--text font-weight-medium"
                    >APPROVED</span
                  >
                </template>
                <span>APPROVED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption red--text font-weight-medium"
                    >REJECTED</span
                  >
                </template>
                <span>REJECTED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption gold--text font-weight-medium"
                    >PARTIALLY APPROVED</span
                  >
                </template>
                <span>PARTIALLY APPROVED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING ON APPROVER LEVEL 2
                  </span>
                </template>
                <span>PENDING ON APPROVER LEVEL 2</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 5">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption blue--text font-weight-medium"
                    >RECOVERED AMOUNT
                  </span>
                </template>
                <span>RECOVERED AMOUNT</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 9">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption blue--text font-weight-medium"
                    >OFFICIAL
                  </span>
                </template>
                <span>OFFICIAL</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == 8">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption blue--text font-weight-medium"
                    >PERSONAL
                  </span>
                </template>
                <span>PERSONAL</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="showContent(item)"
                  small
                  class="mr-2"
                  v-on="on"
                  color="primary"
                  >mdi-eye</v-icon
                >
              </template>
              <span>view details</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="openactionhistorydialog(item)"
                  small
                  class="mr-2"
                  v-on="on"
                  color="green"
                  >mdi-history</v-icon
                >
              </template>
              <span>Action History</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-row class="ml-2 mt-1 mr-2">
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogStart"
                  v-model="modalStart"
                  :return-value.sync="start_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="start_date"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mt-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogStart.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="end_date"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mt-2"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <!-- <v-col lg="2">
                  <label class="caption">Status</label>
                  <v-select v-model="statusType" :items="statusList" dense solo label="Status"></v-select>
              </v-col>-->
              <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                <v-select
                  v-model="statusType"
                  :items="listStatus"
                  item-text="name"
                  item-value="value"
                  dense
                  outlined
                  label="Status"
                  class="mt-2"
                ></v-select>
              </v-col>
              <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                <v-text-field
                  dense
                  shaped
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  class="mt-2"
                  :hint="searchHint"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                lg="1"
                xl="1"
                md="1"
                sm="12"
                xs="12"
                class="mt-1"
              >
                <v-btn
                  small
                  fab
                  text
                  color="primary"
                  class="elevation-0"
                  @click="getExpenseApprData()"
                >
                  <v-icon class="mt-2" dark>mdi-filter</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="contentDialog" max-width="500">
      <v-card>
        <v-toolbar flat color="primary" dense dark>
          <v-toolbar-title>DETAILS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="contentDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12">
              <span class="subtitle-2">
                <b class="primary--text">Expense Name :</b>
                {{ itemfield.expense_name }}
              </span>
              <br />
              <span class="subtitle-2">
                <b class="primary--text">Additonal Info :</b>
                {{ itemfield.additonal_info }}
              </span>
              <br />
              <v-list
                three-line
                v-for="(item, index) in expenseList"
                :key="item.header"
                dense
              >
                <v-list-item :key="item.title">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="item.merchant_name"
                    ></v-list-item-title>

                    <v-list-item-subtitle
                      >Category : {{ item.mcc_desc }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      >#Txn ID : {{ item.rr_number }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle>{{
                      item.txn_type
                    }}</v-list-item-subtitle>

                    <v-list-item-title
                      >{{ item.currency }} {{ item.amount }}</v-list-item-title
                    >
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text
                      v-text="item.txn_timestamp"
                    ></v-list-item-action-text>
                    <v-list-item-avatar
                      size="40"
                      @click="openImageInNewTab(item.Url)"
                    >
                      <v-img :src="item.Url"></v-img>
                    </v-list-item-avatar>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index < expenseList.length - 1"
                  :key="index"
                ></v-divider>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="actiondialog" max-width="1000">
      <v-card>
        <v-toolbar flat class="header" dense dark>
          <v-icon>mdi-history</v-icon>
          <span class="ml-3">Action History</span>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="actiondialog = false">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="elevation-5 pa-3 m align-center">
          <v-data-table
            :headers="headersaction"
            v-model="selected"
            item-key="name"
            dense
            :items="actionhistorydata"
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{
                actionhistorydata.indexOf(item) + 1
              }}</span>
            </template>
            <template v-slot:[`item.submitted_by`]="{ item }">
              <span v-if="item.submitted_by == null" class="caption">--</span>
              <span v-if="item.submitted_by != null" class="caption">{{
                item.submitted_by
              }}</span>
            </template>
            <template v-slot:[`item.submitted_amount`]="{ item }">
              <span v-if="item.submitted_amount == null" class="caption"
                >--</span
              >
              <span v-if="item.submitted_amount != null" class="caption">{{
                item.submitted_amount
              }}</span>
            </template>
            <template v-slot:[`item.approved_amount`]="{ item }">
              <span v-if="item.approved_amount == null" class="caption"
                >--</span
              >
              <span v-if="item.approved_amount != null" class="caption">{{
                item.approved_amount
              }}</span>
            </template>
            <template v-slot:[`item.action_taken_by`]="{ item }">
              <span v-if="item.action_taken_by == null" class="caption"
                >--</span
              >
              <span v-if="item.action_taken_by != null" class="caption">{{
                item.action_taken_by
              }}</span>
              <br />
              <span v-if="item.action_taken_on == null" class="caption"
                >--</span
              >
              <span v-if="item.action_taken_on != null" class="caption">{{
                item.action_taken_on
              }}</span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <span
                class="caption gold--text font-weight-medium"
                v-if="item.action == 'Partially Approved'"
                >{{ item.action }}</span
              >
              <span
                class="caption green--text font-weight-medium"
                v-if="item.action == 'Approved'"
                >{{ item.action }}</span
              >
              <span
                class="caption red--text font-weight-medium"
                v-if="item.action == 'Rejected'"
                >{{ item.action }}</span
              >
              <span
                class="caption blue--text font-weight-medium"
                v-if="item.action == 'Reappeal'"
                >{{ item.action }}</span
              >
              <span
                class="caption blue--text font-weight-medium"
                v-if="item.action == 'Marked as Personal'"
                >{{ item.action }}</span
              >
              <span
                class="caption blue--text font-weight-medium"
                v-if="item.action == 'Marked as Official'"
                >{{ item.action }}</span
              >
            </template>
            <template v-slot:[`item.expensestatus`]="{ item }">
              <div v-if="item.expensestatus == 0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption orange--text font-weight-medium"
                      >PENDING FOR APPROVAL</span
                    >
                  </template>
                  <span>PENDING FOR APPROVAL</span>
                </v-tooltip>
              </div>
              <div v-if="item.expensestatus == 1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption green--text font-weight-medium"
                      >APPROVED</span
                    >
                  </template>
                  <span>APPROVED</span>
                </v-tooltip>
              </div>
              <div v-if="item.expensestatus == 2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="caption red--text font-weight-medium"
                      >REJECTED</span
                    >
                  </template>
                  <span>REJECTED</span>
                </v-tooltip>
              </div>
              <div v-if="item.expensestatus == 3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption pink--text font-weight-medium"
                      >PARTIALLY APPROVED</span
                    >
                  </template>
                  <span>PARTIALLY APPROVED</span>
                </v-tooltip>
              </div>
              <div v-if="item.expensestatus == 4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption green--text font-weight-medium"
                      >AMOUNT COLLECTED</span
                    >
                  </template>
                  <span>AMOUNT COLLECTED</span>
                </v-tooltip>
              </div>
              <div v-if="item.expensestatus == 5">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      class="caption grey--text font-weight-medium"
                      >RE-APPEAL</span
                    >
                  </template>
                  <span>RE-APPEAL</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.action_level`]="{ item }">
              <span v-if="item.action_level == null" class="caption">--</span>
              <span v-if="item.action_level != null" class="caption">{{
                item.action_level
              }}</span>
            </template>
          </v-data-table></v-card
        >
      </v-card>
    </v-dialog>
    <OverleyProccessg :overlay="overlay" />
    <ExpenseHistoryView
      v-if="Show == true"
      :ExpenseList="ExpenseList"
      @backOn="callstatus()"
      :expenseid="expenseid"
      :expstatus="expstatus"
      :PropItem="PropItem"
    />
    <!-- :viewHistoryArray="viewHistoryArray"
      :receiptStatus="receiptStatus"
      @clicked="receiptStatus = false" -->
  </div>
</template>
<script>
import ExpenseHistoryView from "@/components/ExpenseSubFol/ExpenseHistoryView.vue";
// import Viewreciept from "@/components/ExpenseSubFol/Viewreciept.vue";

//import ApproveViewDetailsCust from "@/components/CustomerSubfolder/ApproveViewDetailsCust.vue";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
    // Viewreciept,
    ExpenseHistoryView,
  },
  data: () => ({
    expenseid: "",
    Show: false,
    expstatus: 0,
    modalEnd: "",
    modalStart: "",
    expenseList: [],
    accesscheckk: false,
    contentDialog: false,
    start_date: null,
    actiondialog: false,
    end_date: null,
    statusType: 0,
    actionhistorydata: [],
    listStatus: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "Pending On Approver Level 2",
        value: 4,
      },
      {
        name: "Approved",
        value: 1,
      },
      {
        name: "Rejected",
        value: 2,
      },
      {
        name: "Partially Approved",
        value: 3,
      },
      {
        name: "Appealed",
        value: 6,
      },
      {
        name: "Official",
        value: 9,
      },
      {
        name: "Personal",
        value: 8,
      },
    ],
    receiptStatus: false,
    viewHistoryArray: [],
    searchHint: "expense name",

    workflowType: "Customer Onboarding",
    ExpenseList: [],
    headersaction: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "SUBMITTED BY",
        align: "start",
        sortable: false,
        value: "submitted_by",
      },
      {
        text: "SUBMITTED AMT",
        align: "start",
        sortable: false,
        value: "submitted_amount",
      },
      {
        text: "APPROVED AMT",
        align: "start",
        sortable: false,
        value: "approved_amount",
      },

      {
        text: "ACTED BY/ON",
        align: "start",
        sortable: false,
        value: "action_taken_by",
      },

      {
        text: "ACTION LEVEL",
        value: "action_level",
        align: "start",
        sortable: false,
      },
      {
        text: "STATUS",
        align: "start",
        sortable: false,
        value: "action",
      },
    ],
    headers: [
      { text: "SL NO", value: "sl_no" },
      // align: ' d-none'
      {
        text: "NAME",
        align: "start",
        sortable: false,
        value: "user_detail",
      },
      {
        text: "EXPENSE NAME",
        align: "start",
        sortable: false,
        value: "expense_name",
      },

      // {
      //   text: "Initiated On",
      //   value: "initiated_on",
      //   align: "start",
      //   sortable: false,
      // },

      {
        text: "AMOUNT",
        value: "total_amount",
        align: "start",
        sortable: false,
      },
      {
        text: "APPROVED AMT",
        value: "approved_amount",
        align: "start",
        sortable: false,
      },
      {
        text: "APPEAL STATUS",
        value: "request_type",
        align: "start",
        sortable: false,
      },
      {
        text: "STATUS",
        value: "status",
        align: "start",
        sortable: false,
      },
      {
        text: "DATE & TIME",
        value: "created_on",
        align: "start",
        sortable: false,
      },
      {
        text: "ACTION",
        value: "actions",
        align: "start",
        sortable: false,
      },
    ],
    overlay: false,
    search: "",
    itemfield: "",
    selected: "",
    itemsPerPage: 15,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    PropItem: {},
    Nodata: "",
  }),
  created() {
    // alert(20)
    // console.log(" this.start_date", this.end_date);
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);

    this.checkaccess();
  },
  mounted() {
    this.getExpenseApprData();
  },
  watch:{
    Show(val){
      if(val == true){
        this.$emit("Showvalue3", val);
       
      }else{
        this.$emit("Showvalue3", val);
      }
    }
  },
  methods: {
    callstatus() {
      this.Show = false;
      this.getExpenseApprData();
    },
    openactionhistorydialog(item) {
      //console.log("data", data);
      this.getactionhistory(item.expense_id);
      this.actionhistorydata = [];
      this.actiondialog = true;
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    async getactionhistory(value) {
      this.overlay = true;
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETEXHI",
          expense_id: value,
        },
      };
      var responseData = await apiCall(inputData);
      //console.log("responseData11", responseData.data);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.actionhistorydata = responseData.data.data;
        }
        this.overlay = false;
        //console.log("this.actionhistorydata", this.actionhistorydata);
      } else {
        this.overlay = false;
        this.actionhistorydata = [];
      }
    },

    async getExpenseApprDataPagination() {
      if (this.expenseList.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;
        this.overlay = true;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "EXPENSE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "GETEXPHIS",
            search_text: this.search,
            from_date: this.start_date,
            to_date: this.end_date,
            corp_id: this.$store.getters.get_corpid,
            user_id: this.$store.getters.get_userid,
            exp_status: this.statusType,
            // approver_type: "3",
          },
        };

        var responseData = await apiCall(inputData);

        this.expenseList = this.expenseList.concat(responseData.data.data);
        this.overlay = false;
      }
    },
    async getExpenseApprData() {
      this.overlay = true;

      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETEXPHIS",
          search_text: this.search,
          from_date: this.start_date,
          to_date: this.end_date,
          corp_id: this.$store.getters.get_corpid,
          user_id: this.$store.getters.get_userid,
          exp_status: this.statusType,
          // approver_type: "3",
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log("responseData", responseData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.expenseList =
            responseData.data.data == null ? [] : responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.expenseList = [];
      }
      this.overlay = false;
    },
    async showContent(item) {
      this.overlay = true;
      if (item.transaction_id != null || item.transaction_id != "") {
        this.expenseid = item.expense_id;
        this.expstatus = item.status;

        this.PropItem = item;
      }
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GEXPTXN",
          expense_id: item.expense_id,
        },
      };
      var responseData = await apiCall(inputData);
      //console.log("responseData.data.data)", responseData.data.data);

      this.ExpenseList =
        responseData.data.data == null ? [] : responseData.data.data;
      if (responseData.data.status == "00") {
        this.Show = true;
      } else {
        this.Show = false;
      }
      // this.expenseList.forEach((element) => {
      //   element.Url =
      //     element.receipt_url != null ? element.receipt_url[0] : null;
      //   element.classValue =
      //     element.amount > element.expense_rules.amount
      //       ? "font-weight-bold red--text"
      //       : "font-weight-bold";
      //   element.classValue2 =
      //     element.amount > element.expense_rules.amount
      //       ? "font-weight-bold red--text"
      //       : "font-weight-medium";
      // });
      // this.receiptStatus = true;
      // this.ExpenseHistoryView = responseData.data.data;
      // //console.log("viewHistoryArray", this.viewHistoryArray);
      // this.overlay = false;
      // this.receiptStatus = true;
      // this.$refs.ExpenseHistoryView.receiptStatus = true;
      // this.$refs.ExpenseHistoryView.itemfield = item;
      // this.$refs.ExpenseHistoryView.itemfield.usertype =
      //   this.expenseList.length == 0
      //     ? "-"
      //     : this.expenseList[0].expense_rules.usertype;
      // this.$refs.ExpenseHistoryView.itemfield.usertype_name =
      //   this.expenseList.length == 0
      //     ? "-"
      //     : this.expenseList[0].expense_rules.usertype_name;
      // var self = this;
      // self.expenseList.forEach(function (ele) {
      //   ele.approval_status1 = ele.approval_status;
      // });
      // this.$refs.ExpenseHistoryView.expenseList = this.expenseList;

      //console.log(this.$refs.ExpenseHistoryView);
      this.overlay = false;
    },
    async checkaccess() {
      // alert(30);
      this.expandcheck = false;
      // this.$router.push("/accessdenied");
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "EXMGMT",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(responseData, "responsCHECK_ACCESSeData");
      var checkaccessdata = responseData.data.data;
      // checkaccessdata.is_approver = false;
      // checkaccessdata.is_checker = false;
      // checkaccessdata.is_maker = false;
      // checkaccessdata.is_viewer = false;
      if (
        checkaccessdata.is_approver == false &&
        checkaccessdata.is_checker == false &&
        checkaccessdata.is_maker == false &&
        checkaccessdata.is_viewer == false
      ) {
        this.accesscheckk = true;
      }
    },
    getFileName(filename) {
      //console.log("vvv", filename);
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>
